/*
 * Created on Thu Oct 12 2023 10:25:02 AM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */
import { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import validator from "validator";
import { forgotPassword } from "../../api/action/user";

const ForgotPassword = (props) => {
  const [user, setUser] = useState({ email: "" });
  const [flag, setFlag] = useState(false);
  const [error, setError] = useState("");
  const [emailError, setEmailError] = useState(false);
  const nav = useNavigate();
  const companyState = useSelector((state) => state.companyReducer.company);

  const logoUrl = companyState?.logoLocation;

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "email") {
      setUser((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleBlur = () => {
    if (!validator.isEmail(user.email)) {
      setEmailError(true);
    } else {
      setEmailError(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validator.isEmail(user.email)) {
      setEmailError(true);
      return;
    }

    //  Construct correct payload
    const payload = {
      email: user.email,
      company: { primaryId: companyState?.primaryId },
    };

    props
      .forgotPassword(payload)
      .then(() => {
        setFlag(true);
        setError(
          "Please check your email to reset your password./The link will expire in 15 minutes."
        );
        setUser({ email: "" });
      })
      .catch((err) => {
        setFlag(false);

        const backendMessage =
          err.response?.data?.message ||
          err.response?.data?.error ||
          (typeof err.response?.data === "string" ? err.response.data : null);

        if (backendMessage) {
          setError(backendMessage);
        } else {
          setError("User not found.");
        }
      });
  };

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn) {
      nav("/products");
    }
  }, [nav]);

  const customizedError = error.split("/");

  return (
    <div className="flex flex-col items-center w-full min-h-screen pt-24 px-4 overflow-y-auto">
      <div className="bg-white shadow-md rounded p-5 sm:p-8 w-full max-w-lg">
        <img
          loading="lazy"
          src={logoUrl}
          alt="logo"
          className="w-20 h-20 mx-auto"
        />

        <h1 className="text-center text-xl font-semibold text-gray-800 mb-6">
          Forgot Password
        </h1>

        {error && (
          <div
            className={`text-center ${flag ? "text-green-600" : "text-red-600"
              }`}
          >
            <p>{customizedError[0]}</p>
            {customizedError[1] && <p>{customizedError[1]}</p>}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700"
            >
              Email
            </label>
            <input
              id="email"
              name="email"
              type="email"
              value={user.email}
              onChange={handleChange}
              onBlur={handleBlur}
              className="block w-full px-4 py-3 lg:py-2 border border-gray-300 rounded focus:ring focus:ring-blue-300 focus:outline-none"
              required
            />
            {emailError && (
              <span className="text-sm text-red-600">
                Please enter a valid email
              </span>
            )}
          </div>
          <div className="flex justify-center mt-4">
            <button
              type="submit"
              className="w-full sm:w-auto px-6 py-3 lg:py-2 text-white rounded font-bold bg-blue-600 hover:bg-blue-700"
            >
              Get the Link
            </button>
          </div>
        </form>

        <div className="mt-6 text-center">
          <a href="/forgot-email" className="text-blue-600 hover:underline">
            Forgot Email
          </a>
        </div>
        <hr className="my-4" />
        <div className="text-center">
          <p>
            Or{" "}
            <a href="/sign-in" className="text-blue-600 hover:underline">
              Sign in
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  const { isAuthenticated, user } = state?.auth?.data || {};
  return { isAuthenticated, user };
}

export default connect(mapStateToProps, { forgotPassword })(ForgotPassword);
